module.exports = __webpack_public_path__ + "img/twitter.a57ea219.svg";